import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom"
import Images from '../../Images'

import './styles.less'

function NotFoundPage(props) {
  const {auth} = props;

  let history = useHistory();

  function handleNavigate(path) {
    history.push(path);
  }

  return (
    <div className="not-found"
         onClick={() => handleNavigate(auth.userInfo ? (auth.userInfo.onboarding_finished ? '/dashboard' : '/onboarding/plan') : '/login')}>
      <img src={Images.logo} alt=""/>
      <div className="not-found-content">
        <div>404</div>
        <p>Unfortunately, this page doesn’t exist.</p>
        <p>Try <Link to={auth.userInfo ? (auth.userInfo.onboarding_finished ? '/dashboard' : '/onboarding/plan') : '/login'}>
          start from the main page
        </Link>
        </p>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(NotFoundPage)
